module.exports = __webpack_public_path__ + "img/logo1.7a680fcd.png";